module.exports = __webpack_public_path__ + "img/ignis-2022.a1e2270f.svg";